import { httpRequest } from './Axios';

/* ── Auth (public — no x-api-key needed) ── */
export const PW_Login_API = async (data) => {
  return await httpRequest({ method: 'POST', url: '/auth/login', data }, false);
};

/* ── Master Data ── */
export const PW_Products_API = async () => {
  return await httpRequest({ method: 'GET', url: '/products' });
};

export const PW_Stores_API = async () => {
  return await httpRequest({ method: 'GET', url: '/stores' });
};

export const PW_Users_API = async () => {
  return await httpRequest({ method: 'GET', url: '/users' });
};

export const PW_Calendar_API = async () => {
  return await httpRequest({ method: 'GET', url: '/calendar' });
};

/* ── Transactions ── */
export const PW_Transactions_List_API = async (params) => {
  return await httpRequest({ method: 'GET', url: '/transactions', params });
};

export const PW_Transaction_Save_API = async (data) => {
  return await httpRequest({ method: 'POST', url: '/transactions', data }, false);
};

/* ── Save endpoints (fire-and-forget from UI) ── */
export const PW_User_Save_API = async (data) => {
  return await httpRequest({ method: 'POST', url: '/users', data }, false);
};
export const PW_User_Delete_API = async (id) => {
  return await httpRequest({ method: 'DELETE', url: `/users/${id}` }, false);
};
export const PW_UserStoreRight_Save_API = async (data) => {
  return await httpRequest({ method: 'POST', url: '/users/rights', data }, false);
};
export const PW_Store_Save_API = async (data) => {
  return await httpRequest({ method: 'POST', url: '/stores', data }, false);
};
export const PW_Store_Delete_API = async (id) => {
  return await httpRequest({ method: 'DELETE', url: `/stores/${id}` }, false);
};
export const PW_Product_Save_API = async (data) => {
  return await httpRequest({ method: 'POST', url: '/products', data }, false);
};
export const PW_ProductTypeLink_Toggle_API = async (data) => {
  return await httpRequest({ method: 'POST', url: '/products/link-toggle', data }, false);
};
export const PW_WinnerConfig_Save_API = async (data) => {
  return await httpRequest({ method: 'POST', url: '/products/winner-config', data }, false);
};
export const PW_ProductType_Save_API = async (data) => {
  return await httpRequest({ method: 'POST', url: '/products/types', data }, false);
};
export const PW_Calendar_Save_API = async (data) => {
  return await httpRequest({ method: 'POST', url: '/calendar', data }, false);
};
export const PW_Calendar_Delete_API = async (id) => {
  return await httpRequest({ method: 'DELETE', url: `/calendar/${id}` }, false);
};

/* ── Bonus Prize Schedules ── */
export const PW_BonusPrize_API = async () => {
  return await httpRequest({ method: 'GET', url: '/bonus-prizes' });
};
export const PW_BonusPrize_Save_API = async (data) => {
  return await httpRequest({ method: 'POST', url: '/bonus-prizes', data }, false);
};
export const PW_BonusPrize_Delete_API = async (id) => {
  return await httpRequest({ method: 'DELETE', url: `/bonus-prizes/${id}` }, false);
};
